import { hexToRgbA, getLightenColor, getDarkenColor } from './'

export default (type, colors) => {
  const styles = {
    default: {
      'rc-calendar': {
        customCSS: `
          body .rc-calendar-column-header,
          body .rc-calendar-input {
            color: ${colors.dark};
          }
          body .rc-calendar-year-select:hover, 
          body .rc-calendar-month-select:hover, 
          body .rc-calendar-day-select:hover, 
          body .rc-calendar-today-btn:hover, 
          body .rc-calendar-ok-btn:hover, 
          body .rc-calendar-time-picker-btn:hover, 
          body .rc-calendar-year-select:active, 
          body .rc-calendar-month-select:active, body .rc-calendar-day-select:active, 
          body .rc-calendar-today-btn:active, body .rc-calendar-ok-btn:active, 
          body .rc-calendar-time-picker-btn:active, 
          body .rc-calendar-year-select:focus,
          body .rc-calendar-month-select:focus, 
          body .rc-calendar-day-select:focus, 
          body .rc-calendar-today-btn:focus, 
          body .rc-calendar-ok-btn:focus, 
          body .rc-calendar-time-picker-btn:focus, 
          body .rc-calendar a:hover, 
          body .rc-calendar a:active, 
          body .rc-calendar a:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }
          body .rc-calendar-year-panel-year:hover,
          body .rc-calendar-decade-panel-decade:hover,
          body .rc-calendar-decade-panel-selected-cell .rc-calendar-decade-panel-decade:hover {
            color: ${colors.light}!important;
          }
          body .rc-calendar-year-panel-selected-cell .rc-calendar-year-panel-year:hover,
          body .rc-calendar a {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          body .rc-calendar-selected-day .rc-calendar-date,
          body .rc-calendar-selected-date .rc-calendar-date,
          body .rc-calendar-month-panel-selected-cell .rc-calendar-month-panel-month,
          body .rc-calendar-year-panel-selected-cell .rc-calendar-year-panel-year,
          body .rc-calendar-year-panel-selected-cell .rc-calendar-year-panel-year:hover,
          body .rc-calendar-decade-panel-selected-cell .rc-calendar-decade-panel-decade {
            background: ${getDarkenColor(colors.primary, 0.17)};
          }
          body .rc-calendar-year-select, 
          body .rc-calendar-month-select, 
          body .rc-calendar-day-select, 
          body .rc-calendar-today-btn, 
          body .rc-calendar-ok-btn, 
          body .rc-calendar-time-picker-btn {
            color: ${colors.primary};
          }
          body .rc-calendar-date:hover,
          body .rc-calendar-year-panel-year:hover,
          body .rc-calendar-decade-panel-decade:hover,
          body .rc-calendar-decade-panel-selected-cell .rc-calendar-decade-panel-decade:hover,
          body .rc-calendar-selected-day .rc-calendar-date:hover {
            background: ${colors.primary};
          }
          body .rc-calendar-today .rc-calendar-date {
            border-color: ${getLightenColor(colors.secondary, 0.23)};
          }
          body .rc-calendar-selected-day .rc-calendar-date {
            color: ${colors.light}!important;
          }
          body .rc-calendar-footer {
            border-color: ${getLightenColor('#C4C4C4', 0.2)};
          }
          body .rc-calendar-date-input-wrap input {
            box-shadow: inset 0px 2px 9px ${hexToRgbA(colors.dark, 0.1)};
          }
          body .rc-calendar-clear-btn:after {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          body .rc-calendar-clear-btn:after,
          body .rc-calendar-clear-btn:hover:after{
            color: ${colors.primary};
          }
          td:not(.rc-calendar-last-month-cell) .rc-calendar-date {
            color: ${colors.dark};
          }
          td:not(.rc-calendar-last-month-cell) .rc-calendar-date:hover {
            color: ${colors.light};
          }
        `
      },
      'form-message': {
        customCSS: `
          .form-message.state-success {
            background: ${getLightenColor(colors.primary, 2)};
          }
          .form-message.state-error {
            background: ${colors.info};
            color: ${colors.light};
          }
          .form-message.state-error a:hover, 
          .form-message.state-error a:active, 
          .form-message.state-error a:focus {
            color: ${getDarkenColor(colors.primary, 0.17)};
            background-image: linear-gradient(rgba(0, 0, 0, 0) 50%, ${getDarkenColor(colors.primary, 0.17)} 50%);
          }
        `
      },
      'input-group': {
        boxShadow: `1px 1px ${getLightenColor(colors.secondary, 0.21)}`
      },
      'form-actions': {
        borderTop: `1px solid ${getLightenColor(colors.secondary, 0.21)}`
      },
      'select': {
        position: 'relative',
        display: 'flex',
        customCSS: `
          .select select {
            background-image: none!important;
          }
          .select:after {
            content: '\\EA07';
            font-family: "mmo-iconfont" !important;
            position: absolute;
            right: 8px;
            top: 0;
            color: ${colors.secondary};
            border-left: 1px solid ${getLightenColor(colors.secondary, 0.21)};
            padding-left: 5px;
            height: 100%;
            line-height: 200%;
            z-index: 1;
          }
        `
      },
    },
    type1: {
      'date-input--input': {
        padding: 0,
        customCSS: `
          .date-input--input input {
            font-size: 16px;
            color: ${colors.dark};
          }
          .date-input--input input::placeholder {
            color: ${colors.dark};
          }
        `
      },
      'input-group': {
        boxShadow: `1px 1px ${getDarkenColor(colors.light, 0.1)}`
      },
      'date-input--action': {
				padding: 0
      },
      'date-input--action__button': {
        fontSize: '36px',
        marginTop: '8px',
        marginRight: '3px',
        fontFamily: 'auto',
        background: colors.light,
        customCSS: `
          .c-results-filters .date-input--action button:hover,
          .c-results-filters .date-input--action button:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
        `
      },
      'search-date-from__label': {
        color: colors.dark,
        fontSize: '12px'
      },
      'select': {
        position: 'relative',
        display: 'flex',
        customCSS: `
          .select select {
            background-image: none!important;
            font-weight: bold;
            z-index: 99;
            position: relative;
          }
          .select:after {
            content: '\\EA07';
            font-family: moon-iconfont!important;
            position: absolute;
            right: 8px;
            top: 6px;
            color: ${colors.primary};
            font-size: 10px;
          }
        `
      },
      'rc-calendar': {
        customCSS: `
          body .rc-calendar {
            width: 100%;
            box-shadow: none;
            border: none;
          }
          body .rc-calendar-header {
            border-bottom: none;
          }
          body .rc-calendar-header a {
            font-family: inherit;
          }
          body .rc-calendar-column-header,
          body .rc-calendar-input {
            color: ${colors.dark};
          }
          body .rc-calendar-date-panel {
            box-shadow: 0px 4px 15px ${hexToRgbA(colors.dark, 0.07)};
            padding-top: 10px;
          }
          body .rc-calendar-month-select {
            padding-right: 0;
          }
          body .rc-calendar-year-select:hover, 
          body .rc-calendar-month-select:hover, 
          body .rc-calendar-day-select:hover, 
          body .rc-calendar-today-btn:hover, 
          body .rc-calendar-ok-btn:hover, 
          body .rc-calendar-time-picker-btn:hover, 
          body .rc-calendar-year-select:active, 
          body .rc-calendar-month-select:active, body .rc-calendar-day-select:active, 
          body .rc-calendar-today-btn:active, body .rc-calendar-ok-btn:active, 
          body .rc-calendar-time-picker-btn:active, 
          body .rc-calendar-year-select:focus,
          body .rc-calendar-month-select:focus, 
          body .rc-calendar-day-select:focus, 
          body .rc-calendar-today-btn:focus, 
          body .rc-calendar-ok-btn:focus, 
          body .rc-calendar-time-picker-btn:focus, 
          body .rc-calendar a:hover, 
          body .rc-calendar a:active, 
          body .rc-calendar a:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }
          body .rc-calendar-year-panel-year:hover,
          body .rc-calendar-decade-panel-decade:hover,
          body .rc-calendar-decade-panel-selected-cell .rc-calendar-decade-panel-decade:hover {
            color: ${colors.light}!important;
          }
          body .rc-calendar-year-panel-selected-cell .rc-calendar-year-panel-year:hover,
          body .rc-calendar a {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          body .rc-calendar-selected-day .rc-calendar-date,
          body .rc-calendar-selected-date .rc-calendar-date,
          body .rc-calendar-month-panel-selected-cell .rc-calendar-month-panel-month,
          body .rc-calendar-year-panel-selected-cell .rc-calendar-year-panel-year,
          body .rc-calendar-year-panel-selected-cell .rc-calendar-year-panel-year:hover,
          body .rc-calendar-decade-panel-selected-cell .rc-calendar-decade-panel-decade {
            background: ${getDarkenColor(colors.primary, 0.17)};
          }
          body .rc-calendar-year-select, 
          body .rc-calendar-month-select, 
          body .rc-calendar-day-select, 
          body .rc-calendar-today-btn, 
          body .rc-calendar-ok-btn, 
          body .rc-calendar-time-picker-btn {
            color: ${colors.primary};
          }
          body .rc-calendar-date:hover,
          body .rc-calendar-year-panel-year:hover,
          body .rc-calendar-decade-panel-decade:hover,
          body .rc-calendar-decade-panel-selected-cell .rc-calendar-decade-panel-decade:hover,
          body .rc-calendar-selected-day .rc-calendar-date:hover {
            background: ${colors.primary};
          }
          body .rc-calendar-today .rc-calendar-date {
            border-color: ${getLightenColor(colors.secondary, 0.23)};
          }
          body .rc-calendar-selected-day .rc-calendar-date {
            color: ${colors.light}!important;
            border: none;
          }
          body .rc-calendar-today-btn {
            font-family: "Helvetica-Neue-LT-Std";
            padding: 7px 0;
            font-size: 14px;
          }
          body .rc-calendar-footer {
            border-top: 1px solid ${getLightenColor('#C4C4C4', 0.2)};
          }
          body .rc-calendar-input-wrap {
            border-bottom: none;
          }
          body .rc-calendar-date-input-wrap input {
            width: 83.33333%;
            float: left;
            padding-left: 0.83333rem;
            padding-right: 0.83333rem;
            padding: 4px 8px;
            box-shadow: inset 0px 2px 9px ${hexToRgbA(colors.dark, 0.1)};
          }
          body .rc-calendar-clear-btn {
            right: 3px;
            top: 8px;
          }
          body .rc-calendar-clear-btn:after {
            font-size: 36px;
            font-family: auto;
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
          body .rc-calendar-clear-btn:after,
          body .rc-calendar-clear-btn:hover:after{
            color: ${colors.primary};
          }
          td:not(.rc-calendar-last-month-cell) .rc-calendar-date {
            color: ${colors.dark};
          }
          td:not(.rc-calendar-last-month-cell) .rc-calendar-date:hover {
            color: ${colors.light};
          }
        `
      },
      'form-message': {
        customCSS: `
          .form-message.state-success {
            background: ${getLightenColor(colors.primary, 2)};
          }
          .form-message.state-error {
            background: ${colors.info};
            color: ${colors.light};
          }
          .form-message.state-error a:hover, 
          .form-message.state-error a:active, 
          .form-message.state-error a:focus {
            color: ${getDarkenColor(colors.primary, 0.17)};
            background-image: linear-gradient(rgba(0, 0, 0, 0) 50%, ${getDarkenColor(colors.primary, 0.17)} 50%);
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/forms.js